import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { isNativeApp } from './platform';
import { extractTokenFromUrl, storeAuthToken } from './authToken';

const MOBILE_AUTH_SCHEME = 'urakarte';

let navigateRef = null;

export function setOAuthNavigate(navigate) {
  navigateRef = navigate;
}

function isOAuthCallbackUrl(urlString) {
  if (!urlString) return false;
  try {
    const url = new URL(urlString);
    if (url.protocol === `${MOBILE_AUTH_SCHEME}:`) {
      return url.pathname.includes('/success') || url.hostname === 'auth';
    }
  } catch {
    return urlString.includes(`${MOBILE_AUTH_SCHEME}://`) && urlString.includes('success');
  }
  return false;
}

async function handleOAuthCallback(urlString) {
  const token = extractTokenFromUrl(urlString);
  if (!token) {
    if (navigateRef) {
      navigateRef('/auth/error?error=missing_token', { replace: true });
    }
    return;
  }

  storeAuthToken(token);
  try {
    await Browser.close();
  } catch {
    // ブラウザが既に閉じている場合
  }

  if (navigateRef) {
    navigateRef('/auth/success', { replace: true });
  }
}

/**
 * ネイティブアプリ起動時に OAuth ディープリンクリスナーを登録する。
 * @returns {() => void} cleanup
 */
export function initMobileOAuthListener() {
  if (!isNativeApp()) return () => {};

  const sub = App.addListener('appUrlOpen', (event) => {
    if (isOAuthCallbackUrl(event.url)) {
      handleOAuthCallback(event.url);
    }
  });

  App.getLaunchUrl()
    .then((result) => {
      if (result?.url && isOAuthCallbackUrl(result.url)) {
        handleOAuthCallback(result.url);
      }
    })
    .catch(() => {});

  return () => {
    sub.then((handle) => handle.remove()).catch(() => {});
  };
}
